<template>
  <div class="user">
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="rank_type" @tab-click="handleClick">
          <el-tab-pane label="个人排行" name="0"></el-tab-pane>
          <el-tab-pane label="团队排行" name="1"></el-tab-pane>
        </el-tabs>
        <el-table :data="tableData" style="width: 100%" border v-loading="loading">
          <el-table-column type="index" :index="indexMethod" label="排名" width="60">
          </el-table-column>
          <el-table-column v-if="rank_type==0" prop="user" label="用户信息">
            <template slot-scope="scope">
              <div class="text-ellipsis" >{{scope.row.real_name}}</div>
              <div class="text-ellipsis" >{{scope.row.mobile}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="unit.unit_name" label="单位名称" >
            <template slot-scope="scope">
              <div class="text-ellipsis" v-if="scope.row.unit">{{scope.row.unit.unit_name}}</div>
            </template>
          </el-table-column>
          <el-table-column  label="单位团队名称" v-if="rank_type==1" >
            <template slot-scope="scope">
              <div class="text-ellipsis" v-if="scope.row.group">{{scope.row.group.unit_group_name}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="task_number"  v-if="rank_type==1"  label="累计次数" >
            <template slot-scope="scope">
              <div class="text-ellipsis" >{{scope.row.task_number}}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="points" label="累计积分" ></el-table-column> -->
          <el-table-column prop="total_step" label="累计步数" ></el-table-column>



        </el-table>

        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
          ></el-pagination>
        </div>
      </div>

      <!--分页-->
      <!-- <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div> -->
    </div>
  </div>
</template>

<script>
import taskApi from '@/api/task.js';

export default {
  components: {

  },
  data() {
    return {
      task_id:'',
      /*横向表单数据模型*/
      searchForm: {
      },
      rank_type:0,
      /*表单数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,

      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      task:'',
      unitList:[],
    };
  },
  created() {
    this.task_id = this.$route.query.task_id;
    /*获取任务列表*/
    this.getTableList();
  },
  methods: {
     indexMethod(index) {
       let self = this;
        return (self.curPage-1)*self.pageSize + index +1;
      },
     handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getTableList();
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getTableList();
    },
    /*获取任务列表*/
    getTableList() {
      let self = this;
      let Params = this.searchForm;
      Params.rank_type = self.rank_type;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      taskApi.rankLists(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },


    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getTableList();
    },
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }

  }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/task/task/rank.vue